import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';

import { checkActionFileSupport } from '../../../../helpers/Mini';

const FileMiniActionsAction = ({
  action,
  file,
  fileLocked,
  runAction,
}) => {
  if (!checkActionFileSupport(action, file).isSupported) {
    return null;
  }

  return (
    <li>
      <a
        id={`file-${file.uuid}-${action.id}`}
        href={`#${action.id}`}
        className={classnames({ disabled: fileLocked })}
        onClick={(e) => {
          e.preventDefault();
          if (action.event && !fileLocked) {
            runAction(action);
          }
        }}
      >
        {action.icon && (
          <i className={action.icon} />
        )}
      </a>
      {action.title && (
        <UncontrolledTooltip fade={false} target={`file-${file.uuid}-${action.id}`}>
          {action.title}
        </UncontrolledTooltip>
      )}
    </li>
  );
};

FileMiniActionsAction.propTypes = {
  action: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  fileLocked: PropTypes.bool.isRequired,
  runAction: PropTypes.func.isRequired,
};

export default FileMiniActionsAction;
